import { stringSubstitution } from '@glowforge/gf-styled/components/contentful-views/util';

const referralTemplate = (referralInfo, products, message) => {
  const productStrings = {
    'referred-by-name': referralInfo?.referrerName,
    'pro-discount': String(products?.pro?.referral?.payment),
    'plus-discount': String(products?.plus?.referral?.payment),
  };

  return stringSubstitution(message, productStrings);
};

export default referralTemplate;
